// extracted by mini-css-extract-plugin
export default {"root":"src-components-base-InputDate-style__bu3y0__root","icon":"src-components-base-InputDate-style__tGxpI__icon","iconLeft":"src-components-base-InputDate-style__WD6yT__iconLeft"};